import type { VoidFunctionComponent } from 'react';

import { Heading } from '../components/Heading';
import PreviewFiltersLayout from '../layout/PreviewFiltersLayout';

import { ExecutiveVulnerabilityOptions } from './ExecutiveVulnerabilityOptions';
import { ExecutiveVulnerabilityPreview } from './ExecutiveVulnerabilityPreview';

/**
 * Dedicated page component for the Executive Vulnerability report.
 * Same layout as the RemediationGuidancePage, minus the format selector: this report is PDF only.
 */
export const ExecutiveVulnerabilityPage: VoidFunctionComponent = () => (
  <main className="padding-left-sm">
    <Heading />
    <PreviewFiltersLayout>
      <PreviewFiltersLayout.Preview>
        <ExecutiveVulnerabilityPreview />
      </PreviewFiltersLayout.Preview>
      <PreviewFiltersLayout.Filters>
        {/* The generate button goes above the options (CORE-7933). */}
        <ExecutiveVulnerabilityOptions />
      </PreviewFiltersLayout.Filters>
    </PreviewFiltersLayout>
  </main>
);
